import {Pipe, PipeTransform} from '@angular/core';
import {IdName} from '../models/id-name.model';

@Pipe({
  name: 'concatNames'
})
export class ConcatNamesPipe implements PipeTransform {

  constructor() {
  }

  transform(array: IdName[]): string {
    if (!array?.length) {
      return '';
    }

    return array.map(item => item.name).join(', ');
  }
}
